var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shops"},[_c('TheHeader',{staticClass:"fixed pin-t w-full z-50"}),_c('div',{staticClass:"site-content relative"},[_c('TheShopsNavigator')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }